import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    seats: null,
    seatHovered: false,
    seatClicked: false,
    seatNo: '',
    error: false,
    loading: true
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_SEATS:
            if(action.seats.status === "failure") {
                return updateObject(state, { seats: null, loading: false })
            }
            return updateObject(state, { seats: action.seats, loading: false });
        case actionTypes.GET_SEATS_FAILED:
            return updateObject(state, { error: true, loading: false });
        case actionTypes.SET_SEATS_LOADING:
            return updateObject(state, { loading: true })
        case actionTypes.HOVER_SEAT:
            return updateObject(state, { seatHovered: true, seatNo: action.val });
        case actionTypes.SEAT_CLICKED:
            return updateObject(state, {seatClicked: true})
        case actionTypes.LEAVE_SEAT:
            return updateObject(state, { seatHovered: false, seatClicked: false });
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/seats.js